export class OfferDiffFormatter {

  static format(changes, schema = []) {

    return changes.map(change => {

      const schemaField = this.findSchema(change.path, schema);

      return {

        ...change,

        group: this.getGroup(change.path),

        label: schemaField?.label ??
          this.getDefaultLabel(change.path),

        icon: this.getIcon(change.path),

        pathText: this.formatPath(change.path)

      };

    });

  }

  static findSchema(path, schema) {

    return schema.find(x => x.path === path);

  }

  static getGroup(path) {

    if (path.startsWith("description"))
      return "Opis";

    if (path.startsWith("productSet"))
      return "Produkt";

    if (path.startsWith("sellingMode"))
      return "Oferta";

    if (path.startsWith("stock"))
      return "Magazyn";

    if (path.startsWith("publication"))
      return "Publikacja";

    if (path.startsWith("payments"))
      return "Płatności";

    if (path.startsWith("delivery"))
      return "Dostawa";

    return "Oferta";
  }

  static getIcon(path) {

    if (path === "name")
      return "fa-tag";

    if (path.startsWith("sellingMode"))
      return "fa-money-bill";

    if (path.startsWith("stock"))
      return "fa-box";

    if (path.startsWith("description"))
      return "fa-align-left";

    if (path.startsWith("publication"))
      return "fa-globe";

    if (path.startsWith("payments"))
      return "fa-file-invoice";

    if (path.startsWith("delivery"))
      return "fa-truck";

    if (path.startsWith("productSet"))
      return "fa-shirt";

    return "fa-pen";
  }

  static getDefaultLabel(path) {

    const map = {

      "name": "Nazwa",

      "sellingMode.price.amount": "Cena",

      "stock.available": "Stan magazynowy",

      "publication.status": "Status",

      "payments.invoice": "Faktura",

      "delivery.handlingTime": "Czas wysyłki",

      "productSet[0].quantity.value": "Ilość"

    };

    return map[path] ?? path;

  }

  static formatPath(path) {

    if (path.startsWith("description.sections")) {

      const match = path.match(/sections\[(\d+)\]/);

      if (match) {

        return `Sekcja ${Number(match[1]) + 1}`;

      }

    }

    if (path.includes("parameters")) {

      const match = path.match(/parameters\[(\d+)\]/);

      if (match) {

        return `Parametr ${Number(match[1]) + 1}`;

      }

    }

    return path;

  }

}